import { createRoute } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { OpsScorecardPage } from "@/components/ops/ops-scorecard-page";
import { useDashboardGrants } from "@/components/ops/use-dashboard-grants";
import { TeamRosterPage } from "@/components/teams/team-roster-page";
import { Route as authenticatedRoute } from "../_authenticated";

const members = [
  {
    name: "Sara Walters",
    title: "Operations Manager",
    ownerId: "f6edcd59-a0fa-4dd8-a8f0-1a49546f34ce",
    image: "/assets/headshots/sara-walters.png",
  },
  {
    name: "Caroline Allred",
    title: "Job Manager",
    ownerId: "e6d65da0-2e79-4560-a7cc-1e49e7d84d1f",
    image: "/assets/headshots/caroline-allred.png",
  },
  {
    name: "Logan Adkins",
    title: "Shipping and Receiving Specialist",
    ownerId: "79eebf85-f675-4556-9262-6b8ec8fd13e8",
    image: "/assets/headshots/logan-adkins.png",
  },
  {
    name: "Adalie Seed",
    title: "Financial and Ops Specialist",
    ownerId: "688e06fa-685f-40b5-b7ed-dc31cc752267",
    image: "/assets/headshots/adalie-seed.png",
  },
];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/fp/operations",
  component: FpOperationsPage,
});

function FpOperationsPage() {
  const { data: session } = useSession();
  const isAdmin = (session?.user as { role?: string } | undefined)?.role === "admin";
  const grants = useDashboardGrants(!isAdmin);
  const canViewKpis = isAdmin || (grants?.includes("operations") ?? false);

  return (
    <TeamRosterPage team="FP Team – Operations" members={members}>
      {canViewKpis && (
        <OpsScorecardPage
          dashboard="operations"
          title="Operations KPIs"
          description="FP quarterly scorecard — on-time delivery, accuracy, quality, repair turnaround"
          embedded
        />
      )}
    </TeamRosterPage>
  );
}
